import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NotLayout = _resolveComponent("NotLayout", true)!

  return (_openBlock(), _createBlock(_component_NotLayout, null, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}